(function () {
  'use strict';
  if (window.HavjoyDeferredAssets) return;
  var configNode = document.getElementById('HjDeferredAssets');
  if (!configNode) return;
  var config = JSON.parse(configNode.textContent), resources = new Map(), groups = new Map();
  function resource(url, style) {
    if (resources.has(url)) return resources.get(url);
    var task = new Promise(function (resolve, reject) {
      var node = style ? document.querySelector('link[data-hj-deferred-href="' + CSS.escape(url) + '"]') : null;
      node = node || document.createElement(style ? 'link' : 'script');
      var timer = setTimeout(failed, 20000);
      function failed() {
        clearTimeout(timer);node.onload = node.onerror = null;
        if (style && node.hasAttribute('data-hj-deferred-href')) node.removeAttribute('href');
        else node.remove();
        reject(new Error('Could not load shopping options. Please retry.'));
      }
      node.onload = function () {clearTimeout(timer);node.onload = node.onerror = null;resolve();};
      node.onerror = failed;
      if (style) {node.rel = 'stylesheet';node.href = url;} else {node.async = false;node.src = url;}
      if (!node.isConnected) document.head.appendChild(node);
    });
    resources.set(url, task);
    task.catch(function () {if(resources.get(url)===task)resources.delete(url);});
    return task;
  }
  function ensure(name) {
    if (groups.has(name)) return groups.get(name);
    var group = config[name] || {scripts:[],styles:[]};
    var scripts = (group.scripts || []).reduce(function (p, url) {return p.then(function () {return resource(url,false);});}, Promise.resolve());
    var task = Promise.all([scripts].concat((group.styles || []).map(function(url){return resource(url,true);}))).then(function () {
      if(name==='drawer'){var drawer=document.querySelector('cart-drawer');if(drawer){drawer.removeAttribute('data-hj-deferred-drawer');if(window.HavjoyDesignPreview)window.HavjoyDesignPreview.hydrate(drawer);}}
    });
    groups.set(name,task);
    task.catch(function(){if(groups.get(name)===task)groups.delete(name);});
    return task;
  }
  window.HavjoyDeferredAssets = {ensure:ensure};
  var cartSelector = '#cart-icon-bubble,[data-action="open-cart"],a[href="/cart"]';
  ['pointerover','focusin','touchstart'].forEach(function(type){document.addEventListener(type,function(e){
    if(e.target.closest(cartSelector))ensure('drawer').catch(function(){});
  },{passive:true});});
  var opening=false;
  document.addEventListener('click',function(e){
    var trigger=e.target.closest(cartSelector);if(!trigger)return;
    e.preventDefault();e.stopImmediatePropagation();if(opening)return;
    opening=true;trigger.setAttribute('aria-busy','true');
    ensure('drawer').then(function(){
      if(!window.CartDrawerController || !window.CartDrawerController.open())throw new Error('Drawer unavailable');
    }).catch(function(){window.location.href=(window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart';})
      .finally(function(){opening=false;trigger.removeAttribute('aria-busy');});
  },true);
})();
